import "./share.css";
import { PermMedia,Label,Room, EmojiEmotions, Cancel } from "@material-ui/icons"
import { useContext, useRef, useState } from "react";
import {AuthContext} from "../../context/AuthContext"
import noAvatar from "./noAvatar.png";
import axios from 'axios';

export default function Share() {
    const {user} = useContext(AuthContext);
    const desc = useRef();
    const [file,setFile] = useState(null);

    const submitHandler = async (e) =>{
        e.preventDefault();
        const newPost = {
            userId: user._id,
            desc: desc.current.value
        }
   
        if(file){
            // const data = new FormData();
            // const fileName = Date.now()+file.name;
            // data.append("name",fileName)
            // data.append("file",file)
            // newPost.img = fileName;

            const formdata = new FormData();
            formdata.append("image", file);

            try{
                const res = await axios.post("https://connect-o.herokuapp.com/single", formdata);
                newPost.img = res.data.data;
            }catch(err){
                console.log(err);
            }
        }
        try{
            await axios.post("https://connect-o.herokuapp.com/api/posts",newPost);
            window.location.reload();
        }catch(err){
            console.log(err);
        }

    }
    return (
        <div className="share">
            <div className="shareWrapper">
                <div className="shareTop">
                    <img src={user.profilepicture || noAvatar} alt="" className="shareProfileImg" />
                    <input 
                        placeholder={"What's in your mind "+user.username+" ?"} 
                        className="shareInput"
                        ref={desc} 
                    />
                </div>
                <hr className="shareHr"/>
                {file && (
                    <div className="shareImgContainer">
                        <img className="shareImg" src={URL.createObjectURL(file)} alt="" />
                        <Cancel className="shareCancelImg" onClick={()=>setFile(null)} />
                    </div>
                )}
                <form className="shareBottom" onSubmit={submitHandler}>
                    <div className="shareOptions">
                        <label htmlFor="file" className="shareOption">
                            <PermMedia htmlColor="tomato" className="shareIcon" />
                            <span className="shareOptionText" >Photo or video</span>
                            <input 
                                style={{display:"none"}} 
                                type="file" 
                                id="file" 
                                accept=".png,.jpeg,.jpg" 
                                onChange={(e)=>setFile(e.target.files[0])} 
                            />
                        </label>
                        <div className="shareOption">
                            <Label htmlColor="blue" className="shareIcon" />
                            <span className="shareOptionText" >Tag</span>
                        </div>
                        <div className="shareOption">
                            <Room htmlColor="green" className="shareIcon" />
                            <span className="shareOptionText" >Location</span>
                        </div>
                        <div className="shareOption">
                            <EmojiEmotions htmlColor="goldenrod" className="shareIcon" />
                            <span className="shareOptionText" >Feelings</span>
                        </div>
                    </div>
                    <button className="shareButton" type="submit" >
                        Share
                    </button>
                </form>
            </div>
        </div>
    )
}
